/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_A1Inputs */

const en_to_xml_faq_a1 = /** @type {(inputs: To_Xml_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The output has an XML declaration, exactly one root element, escaped special characters, and element names that satisfy the XML naming rules, including keys that start with a digit and top level arrays.`)
};

const ko_to_xml_faq_a1 = /** @type {(inputs: To_Xml_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그렇습니다. 출력에는 XML 선언, 정확히 하나의 루트 요소, 이스케이프된 특수 문자, 그리고 XML 이름 규칙을 만족하는 요소 이름이 있습니다. 숫자로 시작하는 키와 최상위 배열도 포함해서입니다.`)
};

const ja_to_xml_faq_a1 = /** @type {(inputs: To_Xml_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。出力には XML 宣言、ちょうど 1 つのルート要素、エスケープされた特殊文字、そして XML の命名規則を満たす要素名があります。数字で始まるキーや最上位の配列も含めてです。`)
};

/**
* | output |
* | --- |
* | "Yes. The output has an XML declaration, exactly one root element, escaped special characters, and element names that satisfy the XML naming rules, including ..." |
*
* @param {To_Xml_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_a1 = /** @type {((inputs?: To_Xml_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_a1(inputs)
	if (locale === "ko") return ko_to_xml_faq_a1(inputs)
	return ja_to_xml_faq_a1(inputs)
});